import { Inject, Injectable, InjectionToken } from '@angular/core';
import { NavigationServiceBase } from 'src/shared/services/navigation-service-base';
import { WINDOW_INJECTION_TOKEN } from '../injection-tokens';
import { CVApiService } from '../reusables/services/cv-api.service';
import { CvConfigurationService } from '../reusables/services/cv-configuration.service';
import { CVLocalizationService } from '../reusables/services/cv-localization.service';
import { SharedServiceHelperService } from '../reusables/services/shared-service-helper.service';
import { IModalService } from 'angular-ui-bootstrap';
@Injectable({
    providedIn: 'root'
})
export class NavigationService extends NavigationServiceBase {
    constructor(
        sshs: SharedServiceHelperService,
        @Inject(WINDOW_INJECTION_TOKEN) window: Window,
        cvApiService: CVApiService,
        cvLocalizationService: CVLocalizationService,
        config: CvConfigurationService,
    ) {
        super(
            sshs.getSharedServicesEnabled(),
            config,
            window,
            cvApiService,
            cvLocalizationService
        );
    }
}
